import TagManager from "react-gtm-module";
import { useGoogleAnalyticsAPI } from "../apis/googleAnalyst/googleAnalyst";

export const useTrackWithGTM = () => {
  const {
    getShiptoTrafficAPI
  } = useGoogleAnalyticsAPI();
 const trackWithGTM = async ({ database, event, pathname, userId,role_id,allstate }) => {
  if (!database) return;
  console.log(allstate.ACA?.customer_account_number ,"this is the state",allstate?.ALA?.customer_billto_account_number,allstate?.userInfo?.loyalty_organization_name)
let shipto = allstate.ALA?.customer_account_number||allstate.ACA?.customer_account_number;


if (!shipto) return;

let values;
      values = {
        shipto:Number(shipto)
      };

  const allowedRoles = [1, 2,3, 4, 5, 6, 7, 8,9.10,13];

  const gtmId =    database === "Henry Schein Dental" ? process.env.REACT_APP_GA_ID_US : process.env.REACT_APP_GA_ID_CA;
console.log( document.referrer,'thisis')
const eventSent = sessionStorage.getItem("ref_event_sent");
  const dataLayerName =  database === "Henry Schein Dental" ? "dataLayerUS" : "dataLayerCA";
  let fullUrl = document.referrer
  let oneWeb = database === "Henry Schein Dental" ? process.env.REACT_APP_ONE_WEB_US : process.env.REACT_APP_ONE_WEB_CA;
  let gep = database === "Henry Schein Dental" ?process.env.REACT_APP_GEP_US : process.env.REACT_APP_GEP_CA;



    window.gtmRegions = window.gtmRegions || {};
    if (!window.gtmRegions[gtmId]) {
        TagManager.initialize({
            gtmId,
            dataLayerName, // 👈 each has its own data layer
          });
          window.gtmRegions[gtmId] = true;
          console.log(`✅ GTM initialized for ${database} (${gtmId})`);
   
    }
  


 
  



  window[dataLayerName] = window[dataLayerName] || [];
  if(pathname.includes("program-benefits") ||pathname.includes("thrive-rewards-promotions")){
   

    let eventName=pathname.includes("program-benefits")?'link_click_benefits':'link_click_promotions'

    window[dataLayerName].push({
      event: eventName,
      page_path: pathname,
      user_id: userId,
      region: database,
      page_url: pathname,
      referrer: document.referrer || "direct",
      screen_resolution: `${window.screen.width}x${window.screen.height}`,
      language: navigator.language,
      link_url: pathname,
      current_route: window.location.pathname,
      device_type:
        /Mobi|Android/i.test(navigator.userAgent) ? "Mobile" : "Desktop",
    });

  }else if((fullUrl.includes(oneWeb) ||fullUrl.includes(gep))&&!eventSent){
    let res = await getShiptoTrafficAPI(values)
  
if(res&&res.data){
  let eventName=res.data.includes("ONEWEB")?'oneweb_link':'gep_link'
  console.log(eventName,"eventName",document.referrer)
  window[dataLayerName].push({
    event: eventName,
    page_path: pathname,
    user_id: userId,
    region: database,
    page_url: window.location.href,
    referrer: document.referrer || "direct",
    device_type:
      /Mobi|Android/i.test(navigator.userAgent) ? "Mobile" : "Desktop",
  });
    sessionStorage.setItem("ref_event_sent", "true");
}
   

  }
  else{
    window[dataLayerName].push({
      event: event,
      page_path: pathname,
      user_id: userId,
      region: database,
      page_url: window.location.href,
      referrer: document.referrer || "direct",
      screen_resolution: `${window.screen.width}x${window.screen.height}`,
      language: navigator.language,
      device_type:
        /Mobi|Android/i.test(navigator.userAgent) ? "Mobile" : "Desktop",
    });

  }

  
    
 
}
return { trackWithGTM };
};
